document.addEventListener('DOMContentLoaded', () => {

  /* disparition du menu bleu lors du scroll ET apparation d'une fleche pour reveniver vers le haut de la page*/

  const menu_secondaire = document.querySelector('.header_menu1');
  const fleche = document.querySelector('.arrow-bottom-right');

  window.addEventListener('scroll', () => {
    const positionScroll = window.scrollY;

    if (positionScroll > 10) {
      menu_secondaire.classList.add('cacher');
      fleche.classList.remove('cacher');
    } else {
      menu_secondaire.classList.remove('cacher');
      fleche.classList.add('cacher');
    }
  });

  // Ajout de l'evenement sur la fleche pour revenir vers le haut de la page
  fleche.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  const iconeBurger = document.querySelector('.burger-icon');
  const iconeCroix = document.querySelector('.croix-icon');
  const menuMobile = document.querySelector('.cacher_mobile');

  iconeBurger.addEventListener('click', () => {
    menuMobile.classList.toggle('cacher_mobile');
    menuMobile.classList.toggle('afficher_mobile');
    console.log('clique');
});

iconeCroix.addEventListener('click', () => {

    menuMobile.classList.toggle('afficher_mobile');
    menuMobile.classList.toggle('cacher_mobile');
});


  // Voir plus description header

  const toggleButton = document.querySelector(
    '.header-interne__description button'
  );
  const description = document.querySelector('.header-interne__description p');
if(toggleButton){
  toggleButton.addEventListener('click', () => {
    console.log('click');

    if (description.classList.contains('expanded')) {
      description.textContent =
        description.textContent.substring(
          0,
          description.getAttribute('data-tronc')
        ) + '...';
      description.classList.remove('expanded');
      toggleButton.textContent = 'Voir plus';
    } else {
      description.textContent = description.getAttribute('data-full-text');
      description.classList.add('expanded');
      toggleButton.textContent = 'Voir moins';
    }
  });
}


});
